import { useEffect, createContext, useState } from 'react';
import { useRouter } from 'next/router';
import { removeUrlHash, setMarcatgeMrec } from '@portal-internet/core';
import { useGlobalVars } from '../../hooks/useGlobalVars';

export const HistoryContext = createContext();

const HistoryProvider = (props) => {
    const { children } = props;
    const { getGlobalVar, resetGlobalVar } = useGlobalVars();
    const router = useRouter();
    const [historyPages, setHistoryPages] = useState([]);

    useEffect(() => {
        setHistoryPages([...historyPages, removeUrlHash(router.asPath, 'mrec')]);

        setMarcatgeMrec(getGlobalVar, resetGlobalVar);
    }, [router]);

    const getPreviousPage = () => {
        if (historyPages.length === 0) return false;
        return historyPages[historyPages.length - 1];
    };

    const hasVisited = (path) => {
        //Verificar si alguna vegada has visitat aquesta pàgina
        return historyPages.some(page => page.includes(path));
    };

    return (
        <HistoryContext.Provider
            value={{
                historyPages,
                getPreviousPage,
                hasVisited
            }}
            children={children}
        />
    );
};

export default HistoryProvider;
